import React from 'react';

import shovelImg from './assets/orange-shovel2.png';
import thirtyPercent from './assets/nei_home_30_2x.png';
import fiftyPercent from './assets/nei_home_50_2x.png';
import { sponsorshipOptionsRoute, contactRoute } from '../../routePaths';
import './homePage.scss';
import { Helmet } from 'react-helmet';
import {getMobileOperatingSystem} from '../../../utils/detectAgent';
/**
 * The HomePage component.
 *
 * @constructor
 */
export class HomePage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
    this.playVideo = this.playVideo.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.logDimensions = this.logDimensions.bind(this);

     this.state = {
       'height':'',
       'width':'',
       'applyMarginLeft':''
     }


  }

  logDimensions() {
    console.log('the height is ',this.state.height);
    console.log('the width is ',this.state.width);
  }

   updateDimensions() {
    let offsetConst = 220
    let applyMarginLeft= (window.innerWidth - 3000)+offsetConst

    this.setState({
      height: window.innerHeight,
      width: window.innerWidth,
      applyMarginLeft
    },()=>{

    });
  }




  componentDidMount() {



  }

  playVideo() {

  }
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {

    var circleImgPath ="./assets/sampleCircleImg.png";
    let applyMarginLeft = this.state.applyMarginLeft;
    let userAgent = getMobileOperatingSystem();
    let ctaLink ='';




     if(userAgent=='iOS'){
      ctaLink='https://itunes.apple.com/us/app/safe-excavator/id1323108596?mt=8';
    }

    else{
      ctaLink='https://play.google.com/store/apps/details?id=com.clearlaunch.safeexcavator';
    }


    return (

      <div id="home-page" className="system-page">
        <Helmet>
          <title>National Excavator Initiative - NEI</title>
          <meta name = "description" content ="Protect yourself, your community, and the infrastructure that makes daily life possible by learning the safety steps necessary protect it." />
        </Helmet>

        <div className="container-fluid">
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col">

                  <h1>Protect yourself, your community, and the infrastructure that makes daily life possible</h1>
                  <p className="last">We invite you to learn more about the infrastructure that is all around you, the safety steps necessary protect it, and the men and women who work incredibly hard to build, install and maintain those systems.</p>
                  <h2>You should know</h2>
                  <ul>
                    <li>Contacting 811 is the first step to identifying underground facilities that make our daily lives possible</li>
                    <li>Subsequent steps are also necessary to protect buried infrastructure as well as those who dig, work or live near the buried facilities</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row statsSection">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="container stats-container">
                    <div className="row">
                      <div className="col-12 col-md-6 pr-1 pl-1">
                        <div className="text-center mb-2 mb-md-0">
                          <img src={thirtyPercent} height="150px" />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 pr-1 pl-1 my-auto">
                        <p className="stats-text text-center text-md-left">of accidents are caused by people who haven't contacted 811.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="container stats-container">
                    <div className="row">
                      <div className="col-12 col-md-6 pr-1 pl-1">
                        <div className="text-center mb-2 mb-md-0">
                          <img src={fiftyPercent} height="150px" />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 pr-1 pl-1 my-auto">
                        <p className="stats-text text-center text-md-left">of accidents are caused by not following safe excavation practices after 811 is contacted.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row body-padding-top">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>Remember</h1>
                  <p>Contact 811 two to three business days before starting projects that involve digging or activities that disrupt the underground. That this needs to happen every time - not just sometimes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );


  }
}

HomePage.propTypes = {};

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js